import VonalkodAdatlapDto from 'app/admin/vonalkodadatlap/dto/VonalkodAdatlapDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class VonalkodAdatlapTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgazoAdatlapTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, VonalkodAdatlapDto)))
				.catch(reject);
		});
	}
}

export default new VonalkodAdatlapTableService();
